module.exports = __webpack_public_path__ + "a7dad7f5d287bc4507bb11b2a49e5602.svg";